import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FrontUserService} from '../../../../core/services/frontUsers.service';

@Component({
    selector: 'add-credits-modal',
    templateUrl: './add-credits.component.html',
    styleUrls: ['./add-credits.component.scss'],
    standalone: false
})

export class AddCreditsComponent {

  users;
  credits;
  showControls = false;
  allowAddCredits = [];
  eventId;
  blockButton = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private userService: FrontUserService,
              public dialogRef: MatDialogRef<AddCreditsComponent>) {
    // this.users = data;
    console.log(data);
    if (data.length) {
      this.credits = data[0].event.credits;
      this.eventId = data[0].event.id;
      this.users = data.map(el => {
        if (el.credits && +el.credits >= this.credits) {
          el.showControl = true;
          this.showControls = true;
        }
        return el;
      }).filter(el => !!el.frontUserId);
    }
  }

  addCredits() {
    if (!this.blockButton) {
      this.blockButton = true;
      if (+this.credits > 0) {
        this.users.forEach((el, index) => {
          if (!el.showControl || (el.showControl && this.allowAddCredits.indexOf(+el.frontUserId) !== -1)) {
            let last = index + 1 === this.users.length;
            this.addCredit(el, last);
          }
        });
      }
    }
  }

  addCredit(creditsData, last?) {
    let data = {eventTypeId: '' , credits: '' , type: '' , fronUserId: '', comment: '', eventId: null};
    data.eventTypeId = creditsData.event.eventTypeId;
    data.credits = this.credits;
    data.type = 'custom';
    data.eventId = this.eventId;
    data.fronUserId = creditsData.frontUserId;
    this.userService.addRewards(data).subscribe((res) => {
      if (res) {
        let userIndex = this.users.findIndex(x => +x.frontUserId === +creditsData.frontUserId);
        if (userIndex !== -1) {
          this.users[userIndex].addCredit = true;
        }
        if (last) {
          setTimeout(() => {
            this.dialogRef.close();
          }, 1000);
        }
        this.userService.updateAllYearsRewards(creditsData.frontUserId).subscribe(result => {

        });
      }
    });
  }

  choose(userId, allow) {
    if (allow) {
      this.allowAddCredits.push(+userId);
    } else {
      let index = this.allowAddCredits.indexOf(+userId);
      if (index !== -1) {
        this.allowAddCredits.splice(index , 1);
      }
    }
  }
}
